import Customer from "./Customer";
import Carrier from "./Carrier";
import OrderItem from "./OrderItem";
import OrderLocation from "./OrderLocation";
import OrderContact from "./OrderContact";
import OrderStatusLog from "./OrderStatusLog";
import BaseModel from "./BaseModel";
import OrderNote from "./OrderNote";
import Document from "./Document";
import DocumentAttachment from "./DocumentAttachment";
import OrderCommit from "./OrderCommit";

export default class Order extends BaseModel {

	static entity = 'orders';
	static route = 'orders';
	static plural = 'orders';
	static singular = 'order';

	static fields () {
		return {
			id: this.attr(null),
			number: this.attr(null),
			customer_id: this.attr(null),
			customer: this.belongsTo(Customer, 'customer_id'),
			carrier_id: this.attr(null),
			carrier: this.belongsTo(Carrier, 'carrier_id'),
			estimate_id: this.attr(null),
			employee_id: this.attr(null),
			fill: this.attr(null),
			carrier_confirmed: this.attr(null),
			carrier_note_id: this.attr(null),
			rate: this.attr(null),
			currency: this.attr(null),
			load_sheet_sent: this.attr(null),
			eta_sent: this.attr(null),
			po_number: this.attr(null),
			pickup: this.attr(null),
			delivery: this.attr(null),
			invoice_number: this.attr(null),
			estimated_date: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
			contact_name: this.attr(null),
			contact_number: this.attr(null),
			contact_email: this.attr(null),
			order_items: this.hasMany(OrderItem, 'order_id', 'id'),
			order_locations: this.hasMany(OrderLocation, 'order_id', 'id'),
			order_contacts: this.hasMany(OrderContact, 'order_id', 'id'),
			order_notes: this.hasMany(OrderNote, 'order_id', 'id'),
			order_status_logs: this.hasMany(OrderStatusLog, 'order_id', 'id'),
			order_commits: this.hasMany(OrderCommit, 'order_id', 'id'),
			documents: this.hasManyThrough(Document, DocumentAttachment, 'model_id', 'id', 'id', 'document_id'),
		}
	}

	static configureApi() {
		let config = super.configureApi();
		config.actions.export = function(id) {
			return this.post('/'+Order.route+'/'+id+'/export', {
				dataTransformer: (response) => {
					return Order.transformDefault(response, 'order');
				}
			});
		};
		config.actions.commit = function(id, data) {
			return this.post('/'+Order.route+'/'+id+'/commit', {data}, {
				dataTransformer: (response) => {
					return Order.transformDefault(response, 'order');
				}
			});
		};
		return config;
	}

	static handleBeforeTransform(data) {
		if(data && data.length) {
			data.forEach((row) => {
				if(row.documents && row.documents.length) {
					row.documents.forEach((document) => {
						DocumentAttachment.insert({data: {
								document_id: document.id,
								model_type: 'Order',
								model_id: row.id,
								ref: null
							}});
					});
				}
			});
		}
		return data;
	}

	static apiConfig = this.configureApi();

	get formattedName() {
		if(this.number && this.po_number) {
			return '#' + this.number + ' (PO: ' + this.po_number + ')';
		} else if(this.number) {
			return '#' + this.number;
		} else if(this.po_number) {
			return 'PO: ' + this.po_number;
		}
		return 'No Identifier Available';
	}

}
